/* eslint-disable react/no-children-prop */
import React from "react";
import { Wrapper, Title, Text } from "../styled";
import { useSelector } from "react-redux";
import { selectPaperworkData, selectPaperworkStageProgress } from "store/PaperWork/selectors";
import { get } from "lodash";
import { isEmpty } from "utils/functions";
import List from "./styled";

const Owners = () => {
  const data = useSelector(selectPaperworkData);
  const owners = get(data, "[0].domainData.owners", []);
  const stageProgress = useSelector(selectPaperworkStageProgress);
  const otherInputsData = get(stageProgress, "[0].otherInputsData", {});
  const isUnconstitutedLand = get(Object.values(otherInputsData)[0], "unconstitutedLand", false);

  if (isUnconstitutedLand)
    return (
      <Wrapper>
        <Title children="Propietario/s" />
        {isEmpty(owners) && <Text children="Sin información" />}
        <List>
          {owners.map((owner, index) => (
            <div key={index}>
              <Text children={`Razón social: ${get(owner, "businessName", "-")}`} />
              <Text children={`Dirección: ${get(owner, "address", "-")}`} />
              <Text children={`CUIT: ${get(owner, "cuit", "-")}`} />
            </div>
          ))}
        </List>
      </Wrapper>
    );

  return (
    <Wrapper>
      <Title children="Propietario/s" />
      {isEmpty(owners) && <Text children="Sin información" />}
      <List>
        {owners.map((owner, index) => (
          <div key={index}>
            <Text children={`Razón social: ${get(owner, "businessName", "-")}`} />
            <Text children={`Fecha de titularización: ${get(owner, "securitizationDate", "-")}`} />
            <Text children={`Domicilio: ${get(owner, "percentage", "-")} %`} />
          </div>
        ))}
      </List>
    </Wrapper>
  );
};

export default Owners;
